import { render, staticRenderFns } from "./analisiCommissioni.vue?vue&type=template&id=4d21af33&"
import script from "./analisiCommissioni.vue.ts?vue&type=script&lang=ts&"
export * from "./analisiCommissioni.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports